import { Component } from '@theme/component';

/**
 * @typedef {Object} DetailsSpecsAnchorRefs
 * @property {HTMLButtonElement} [trigger]
 */

/**
 * PDP "Specifications" anchor link.
 *
 * On click: finds the first element on the page tagged `[data-tech-specs-anchor]`
 * (any of the 3 tech-specs section variants), smooth-scrolls to it, and if that
 * section exposes a tab with `id^="Tab-specs-"`, clicks it to activate the
 * specs panel.
 *
 * Auto-hides itself when no candidate section exists on the page — handled via
 * `:has()` CSS in the snippet's stylesheet (no JS needed for the empty state).
 *
 * @extends {Component<DetailsSpecsAnchorRefs>}
 */
class DetailsSpecsAnchor extends Component {
  /**
   * Handler bound declaratively via `on:click="/handleClick"` in the snippet.
   * @param {MouseEvent} event
   */
  handleClick(event) {
    event.preventDefault();

    const target = document.querySelector('[data-tech-specs-anchor]');
    if (!target) return;

    target.scrollIntoView({ behavior: 'smooth', block: 'start' });

    const specsTab = /** @type {HTMLElement | null} */ (
      target.querySelector('[id^="Tab-specs-"]')
    );
    if (specsTab && specsTab.getAttribute('aria-selected') !== 'true') {
      specsTab.click();
    }
  }
}

if (!customElements.get('details-specs-anchor')) {
  customElements.define('details-specs-anchor', DetailsSpecsAnchor);
}
